<template>
	<div class="p-5">
		<div>
			Är du säker på att du vill avbeställa order: {{ this.order.id }}?<br>
			Det går inte att ångra avbeställningen.
		</div>
		<template v-if="isPrepaid && ! isRefundedAutomatically">
			<div v-if="shouldRequestAccountDetails" class="mt-5">
				<div class="small">(Valfritt) Ange kontouppgifter för snabbare återbetalning.</div>
				<input-text class="mt-4" v-model="accountNumber" placeholder="Kontonummer" hide-valid />
				<input-text class="mt-4" v-model="clearingNumber" placeholder="Clearing" hide-valid />
			</div>
			<div v-else>
				<textarea class="form-control" v-model="comment" placeholder="(Valfritt) Kommentar."></textarea>
			</div>
		</template>
		<div class="d-flex justify-content-end mt-3">
			<text-button
				class="mt-4"
				variant="secondary"
				text="Nej"
				size="small"
				@click="bus.$emit('modal.close')"
			/>
			<text-button
				class="mt-4 ml-4"
				text="Ja, avbeställ ordern"
				variant="destructive"
				size="small"
				@click="cancel"
			/>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';

export default {
	props: {
		order: {
			type: Object,
			required: true,
		},
		isPrepaid: {
			type: Boolean,
			default: false,
		},
		isRefundedAutomatically: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			accountNumber: '',
			clearingNumber: '',
			comment: '',
			bus,
		};
	},
	computed: {
		shouldRequestAccountDetails () {
			const ids = [
				10, // Kostnadsfritt
				27, // Presentkort
			];
			return ids.indexOf(this.order.paymentMethod.id) === -1;
		},
	},
	methods: {
		cancel () {
			if (this.shouldRequestAccountDetails) {
				this.$emit('cancel', {
					accountDetails: {
						accountNumber: this.accountNumber,
						clearingNumber: this.clearingNumber,
					},
				});
			} else {
				this.$emit('cancel', {
					comment: this.comment,
				});
			}
		},
	},
};
</script>